<template>
  <main id="cont">
    <NewAbout />
    <div id="page">
      <Experience  />
      <Skills />
    </div>
  </main>
</template>

<script>
import NewAbout from "../components/newAbout.vue";
import Experience from "../components/Experience.vue";
import Skills from "../components/Skills.vue";
import queryPalette from "../mixins/themeColor.js";

export default {
  title: "Résumé - Nethanzêl's Showroom",

  components: {
    NewAbout,
    Experience,
    Skills
  },

  mounted() {
    this.client();
   /// document.querySelector("#app").style.background = "#fff";

    queryPalette.generatePalette().then((Palette) => {
      document.querySelector("#page").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
      document.querySelector("#page").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
      document.querySelector("#page").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
    });
  },

  methods: {

  }
};
</script>

<style lang="scss" scoped>

#cont {
  margin: 0 5px;
  padding: 0;
}

#page {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1366px;
  margin: 0px auto 0px auto;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;

  position: relative;
  z-index: 10;
}

@media (prefers-color-scheme: dark) {
  #page {
    background-color: #fff;
  }
}

@media (prefers-color-scheme: light) {
  #page {
    background-color: #d1d1d1;
  }
}

</style>
